import React from 'react';
import ReactDOM from 'react-dom';
import '@ifeng-fe/container_channel/common/client/commoncss/resetPC.css';
import Layout from './layout';

/* eslint-disable */
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
